/*
 * @Author: kevinqq 350910378@qq.com
 * @Date: 2025-03-13 09:50:01
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-14 17:56:27
 * @FilePath: \baishu_react_ui\src\utils\createTooltip.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 全局 Tooltip 函数
 * @param {HTMLElement} triggerElement - 触发 Tooltip 的元素
 * @param {string} content - Tooltip 的内容
 * @param {string} position - Tooltip 的位置（top/bottom/left/right）
 * @param {number} offset - Tooltip 与触发元素的间距
 */
export function createTooltip() {
  // 显示 Tooltip
  const show = (triggerElement, content, position = "top", offset = 8) => {

    if (!content) {
      hide();
      return;
    }

    // 创建 Tooltip 元素
    const tooltip =
      document.querySelector(".bsy-tooltip") || document.createElement("div");

    // 将 Tooltip 添加到 body 中
    document.body.appendChild(tooltip);

    const triggerRect = triggerElement.getBoundingClientRect();
    // const tooltipRect = tooltip.getBoundingClientRect();
    tooltip.className = "bsy-tooltip";
    tooltip.classList.add(position);
    tooltip.textContent = content;
    let top, left;

    // 根据位置计算 Tooltip 的坐标
    switch (position) {
      case "top":
        top = triggerRect.top - tooltip.offsetHeight - offset;
        left = triggerRect.left + (triggerRect.width - tooltip.offsetWidth) / 2;
        break;
      case "bottom":
        top = triggerRect.bottom + offset;
        left = triggerRect.left + (triggerRect.width - tooltip.offsetWidth) / 2;
        // console.log(top, left);
        // console.log(triggerRect.left, triggerRect.width, tooltip.offsetWidth);
        break;
      case "left":
        top = triggerRect.top + (triggerRect.height - tooltip.offsetWidth) / 2;
        left = triggerRect.left - tooltip.offsetWidth - offset;
        break;
      case "right":
        top = triggerRect.top + (triggerRect.height - tooltip.offsetWidth) / 2;
        left = triggerRect.right + offset;
        break;
      default:
        top = 0;
        left = 0;
    }

    // 设置 Tooltip 的位置
    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
    tooltip.style.visibility = "visible";
    tooltip.style.opacity = "1";
  };

  // 隐藏 Tooltip
  const hide = () => {
    const tooltip = document.querySelector(".bsy-tooltip");
    if (tooltip) {
      tooltip.style.visibility = "hidden";
      tooltip.style.opacity = "0";
      tooltip.style.top = `-999px`; // 移动到屏幕外 -top 才不会出现滚动条点位 
    }
  };

  // 关闭 Tooltip
  //   const close = () => {
  //     document.body.removeChild(tooltip);
  //   };
  // 绑定事件
  //   triggerElement.addEventListener("mouseenter", showTooltip);
  //   triggerElement.addEventListener("mouseleave", hideTooltip);

  //   // 窗口变化时重新计算位置
  //   window.addEventListener("resize", showTooltip);
  //   window.addEventListener("scroll", showTooltip);
  return {
    show,
    hide,
  };
}
